import {
  Box,
  Container,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Typography,
  Button,
  Modal,
} from "@material-ui/core";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
const AlertNotice = (props) => {
  const { openAlert, alertContent, setOpenAlert } = props;
  return (
    <>
      <Modal
        open={openAlert}
        onClose={() => setOpenAlert(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Alert
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <span>{alertContent}</span>
          </Typography>
          <Typography id="modal-modal-footer" sx={{ mt: 2 }}>
            <Button
              className="cancel_button"
              color="primary"
              variant="contained"
              style={{ float: "right" }}
              onClick={() => setOpenAlert(false)}
            >
              Close
            </Button>
          </Typography>
        </Box>
      </Modal>
    </>
  );
};
export default AlertNotice;
